import { Input } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import BigNumber from 'bignumber.js';
import { IMG_ALT } from 'consts/app';
import Typo from 'consts/typography';
import {
  changeSingleFutureAmount,
  FutureBetModel,
  selectCurrentConverter,
  selectFutureBets,
} from 'features/home/homeSlice';
import { useMemo } from 'react';
import { platformStates } from 'redux/platformSlice';
import { getImg } from 'utils/betUtils';
import { isLaptop, isPhone, isTablet } from 'utils/commonUtils';

interface FutureBetInformationItemProps {
  id: string;
  onDelete: (id: string) => void;
  betType?: 'Single' | 'Combo';
}

const FutureBetInformationItem: React.FunctionComponent<FutureBetInformationItemProps> = ({
  id,
  onDelete,
  betType = 'Single',
}) => {
  const dispatch = useAppDispatch();
  const { isDesktop, isLargeDesktop } = useAppSelector(platformStates);
  const bets = useAppSelector(selectFutureBets);
  const converter = useAppSelector(selectCurrentConverter);
  const betItem: FutureBetModel | undefined = useMemo(
    () => bets.find((x) => x.odd.id === id),
    [bets, id],
  );
  const platform = useAppSelector(platformStates);
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{1,10}$/;
    const value = event.target.value;
    if (value === '' || regex.test(value)) {
      dispatch(changeSingleFutureAmount({ id, amount: Number(value) }));
    }
  };
  return (
    <>
      <div className="bet-information__item">
        <div className="bet-information__item__header">
          <div className="bet-information__item__header-content">
            <img alt={IMG_ALT} src={getImg(betItem?.category as string)} width={20} />
            <span
              className={` primary-text-color ${isDesktop || isLargeDesktop ? Typo.p3 : Typo.p5}`}
            >
              {betItem?.league}
            </span>
          </div>

          {(isPhone(platform) || isTablet(platform) || isLaptop(platform)) &&
            betType === 'Single' && (
              <button onClick={() => onDelete(id)} className="icon-close">
                &#x2718;
              </button>
            )}
        </div>
        <div className="bet-information__item__body">
          <div className="info-bet">
            <div className="number-bet">
              <span className={`${isDesktop || isLargeDesktop ? Typo.p5 : Typo.p7}`}>
                {converter === 'decimal' ? (
                  <>
                    {betItem?.odd.decimalPrice && (
                      <>
                        {`${betItem?.odd.decimalPrice > 0 ? '+' : ''}${new BigNumber(
                          betItem?.odd.decimalPrice,
                        ).toFixed(2)}`}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {betItem?.odd.price && (
                      <>
                        {`${betItem?.odd.price > 0 ? '+' : ''}${new BigNumber(
                          betItem?.odd.price,
                        ).toFixed(0)}`}
                      </>
                    )}
                  </>
                )}
              </span>
            </div>
            <div className="info-bet-right">
              <span
                className={`primary-text-color ${isDesktop || isLargeDesktop ? Typo.p3 : Typo.p5}`}
              >
                {`${betItem?.odd.name}`}
              </span>
            </div>
          </div>
          {(isPhone(platform) || isTablet(platform) || isLaptop(platform)) &&
            betType === 'Single' && (
              <div>
                <Input
                  name="input-value"
                  className={`input-secondary ${
                    isDesktop || isLargeDesktop ? Typo.p1 : Typo.p2
                  } input-field`}
                  placeholder="Bet Amount"
                  onChange={onChange}
                  value={bets.find((bet) => bet.odd.id === id)?.singleAmount || 0}
                />
              </div>
            )}
        </div>
      </div>
      <div>
        {!(isPhone(platform) || isTablet(platform) || isLaptop(platform)) &&
          betType === 'Single' && (
            <div>
              <Input
                name="input-value"
                className={`input-secondary ${
                  isDesktop || isLargeDesktop ? Typo.p1 : Typo.p2
                } input-field`}
                placeholder="Bet Amount"
                onChange={onChange}
                value={bets.find((bet) => bet.odd.id === id)?.singleAmount || 0}
              />
              <button onClick={() => onDelete(id)} className="icon-close">
                &#x2718;
              </button>
            </div>
          )}
        {betType === 'Combo' && (
          <button onClick={() => onDelete(id)} className="icon-close">
            &#x2718;
          </button>
        )}
      </div>
    </>
  );
};

export default FutureBetInformationItem;
